import React from 'react';
import { View, ActivityIndicator, StyleSheet, ViewStyle } from 'react-native';

interface OverlayLoaderProps {
  visible: boolean; 
  color?: string; 
  style?: ViewStyle; 
}

const OverlayLoader: React.FC<OverlayLoaderProps> = ({ visible, color = '#ffffff', style }) => {
  if (!visible) return null; 

  return (
    <View testID="overlay-loader" style={[styles.overlay, style]}>
      <ActivityIndicator size="large" color={color} testID='activity-indicator' />
    </View>
  );
};

const styles = StyleSheet.create({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.7)', 
    zIndex: 1000, 
  },
});

export default OverlayLoader;
